/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_ResourcesInputs */

const id_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumber daya`)
};

const ms_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumber`)
};

const da_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressourcer`)
};

const de_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressourcen`)
};

const en_us2_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources`)
};

const es_es2_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recursos`)
};

const es_mx2_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recursos`)
};

const fil_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Resource`)
};

const fr_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressources`)
};

const it_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risorse`)
};

const hu_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Források`)
};

const nl_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronnen`)
};

const no_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressurser`)
};

const pl_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zasoby`)
};

const pt_br2_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recursos`)
};

const pt_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recursos`)
};

const ro_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resurse`)
};

const fi_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resurssit`)
};

const sv_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resurser`)
};

const vi_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài nguyên`)
};

const tr_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaynaklar`)
};

const cs_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdroje`)
};

const bg_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ресурси`)
};

const ru_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ресурсы`)
};

const uk_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ресурси`)
};

const ar_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الموارد`)
};

const hi_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संसाधन`)
};

const th_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทรัพยากร`)
};

const ja_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リソース`)
};

const zh_cn2_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资源`)
};

const zh_hant1_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`資源`)
};

const ko_footer_resources = /** @type {(inputs: Footer_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리소스`)
};

/**
* | output |
* | --- |
* | "Resources" |
*
* @param {Footer_ResourcesInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const footer_resources = /** @type {((inputs?: Footer_ResourcesInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_ResourcesInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_footer_resources(inputs)
	if (locale === "ms") return ms_footer_resources(inputs)
	if (locale === "da") return da_footer_resources(inputs)
	if (locale === "de") return de_footer_resources(inputs)
	if (locale === "en-US") return en_us2_footer_resources(inputs)
	if (locale === "es-ES") return es_es2_footer_resources(inputs)
	if (locale === "es-MX") return es_mx2_footer_resources(inputs)
	if (locale === "fil") return fil_footer_resources(inputs)
	if (locale === "fr") return fr_footer_resources(inputs)
	if (locale === "it") return it_footer_resources(inputs)
	if (locale === "hu") return hu_footer_resources(inputs)
	if (locale === "nl") return nl_footer_resources(inputs)
	if (locale === "no") return no_footer_resources(inputs)
	if (locale === "pl") return pl_footer_resources(inputs)
	if (locale === "pt-BR") return pt_br2_footer_resources(inputs)
	if (locale === "pt") return pt_footer_resources(inputs)
	if (locale === "ro") return ro_footer_resources(inputs)
	if (locale === "fi") return fi_footer_resources(inputs)
	if (locale === "sv") return sv_footer_resources(inputs)
	if (locale === "vi") return vi_footer_resources(inputs)
	if (locale === "tr") return tr_footer_resources(inputs)
	if (locale === "cs") return cs_footer_resources(inputs)
	if (locale === "bg") return bg_footer_resources(inputs)
	if (locale === "ru") return ru_footer_resources(inputs)
	if (locale === "uk") return uk_footer_resources(inputs)
	if (locale === "ar") return ar_footer_resources(inputs)
	if (locale === "hi") return hi_footer_resources(inputs)
	if (locale === "th") return th_footer_resources(inputs)
	if (locale === "ja") return ja_footer_resources(inputs)
	if (locale === "zh-CN") return zh_cn2_footer_resources(inputs)
	if (locale === "zh-Hant") return zh_hant1_footer_resources(inputs)
	return ko_footer_resources(inputs)
});
export { footer_resources as "footer.resources" }